import Button from '@material-ui/core/Button';
import * as React from 'react';
import { AuthenticationContext, runWithAdal } from 'react-adal';
import { getAdalConfig } from 'src/effects/api/api.userAuth';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

export default class UnicefLoginComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.AuthenticateUnicefUser = this.AuthenticateUnicefUser.bind(this);
    }

    AuthenticateUnicefUser() {

        getAdalConfig().then((adalConfig) => {
            if (adalConfig) {
                const authContextLocal = new AuthenticationContext(adalConfig)
                runWithAdal(authContextLocal, true);
            }
        })

        // runWithAdal(authContext, true);
    }

    render() {
        return (
            <>
                <Button
                    type="submit"
                    fullWidth={true}
                    variant="contained"
                    color="primary"
                    className="unicefSignIn"
                    onClick={this.AuthenticateUnicefUser}
                >
                    Sign In  <ChevronRightIcon  className="ChevronRightIcon"/>
          </Button>
                {/* <p className="unciefNotice">
                    This would be UNICEF’s internal Auth system
                </p> */}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/unicefLogin/unicefLoginComponent.tsx